import { UPDATE_SELECTED_ITINERY } from './types'

export const updateSelectedItinery = (id) => {
  return {
    type: UPDATE_SELECTED_ITINERY,
    payload: id
  }
}